import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  competitions,
  regions,
  sports
} from 'utils/constants/sportsbook/data-fields';
import { getLivePreMatchSportTypes } from 'utils/sportsbook/sport-data';
import RidGenerator from 'utils/swarm/rid-generator';
import { Sport } from 'interfaces/sportsbook-data-levels';
import { executeCommand, unsubscribeCommand } from 'services/get-data-level';
import { ADVANCED_LEFT_MENU_DATA_REDUX_KEY } from 'newelements/Sportsbook/layouts/advanced/Desktop/__partials/AdvancedLeftSideBar/AdvancedLeftMenu';
import { useSportsbookConfigs } from 'hooks/sportsbook/useSportsbookConfigs';
import { useMounted } from 'hooks/useMounted';
import { setSwarmResponse } from 'store/actions/new-sportsbook';

export const useGetAdvancedSportsMainData = () => {
  const { sportType } = useSportsbookConfigs();

  const { mounted } = useMounted();
  const dispatch = useDispatch();

  useEffect(() => {
    const rid = RidGenerator.gForSubscribe('ADVANCED_LEFT_MENU');

    const what = {
      sport: sports.sport,
      competition: competitions.competition,
      region: regions.region,
      game: ['type', 'start_ts']
    };

    const where = {
      ...(sportType
        ? {
            sport: {
              type: {
                '@in': getLivePreMatchSportTypes(sportType)
              }
            }
          }
        : {}),
      game: { type: { '@in': [0, 1, 2] } }
    };

    const onResponse = (resp: { sport: Record<string, Sport> }) => {
      if (resp && resp.sport && mounted.current) {
        dispatch(
          setSwarmResponse({ [ADVANCED_LEFT_MENU_DATA_REDUX_KEY]: resp.sport })
        );
      }
    };

    const onDataNotFoundOrError = () => {
      dispatch(setSwarmResponse({ [ADVANCED_LEFT_MENU_DATA_REDUX_KEY]: {} }));
    };

    executeCommand(
      rid,
      what,
      where,
      onResponse,
      true,
      onResponse,
      onDataNotFoundOrError
    );

    return () => {
      unsubscribeCommand(rid);
    };
  }, []);
};
